import React, { useState, useEffect } from "react";
import DropdownUser from "./DropdownUser";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { login_Success } from "../../redux/auth/authSlice";
import Breadcrumb from "../Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { BiChevronLeft } from "react-icons/bi";
import { logout } from "../../redux/auth/authSlice";
import jsonData from "./Pages.json";
import AvatarDropdown from "./AvatarDropdown";
import Notification from "./Notification";
import { useBigContext } from "utils/bigContext";

const Navbar = (props) => {
  const { id, id2, id3 } = useParams();
  const cookies = document.cookie.split(";").reduce((prev, curr) => {
    const [name, value] = curr.trim().split("=");
    prev[name] = value;
    return prev;
  }, {});
  const [Id, setID] = useState(cookies.ID);
  const [pageName, setPageName] = useState("");
  const navigate = useNavigate();
  const [breadcrumbVariable, setBreadcrumbVariable] = useState(false);
  const [changer, setChanger] = useState(false);
  const [applicantId, setApplicantId] = useState("");
  const [applicantId2, setApplicantId2] = useState("");

  const login = `${window.globalConfig.BASE_URL2}/api/Login`;
  const users = `${window.globalConfig.BASE_URL2}/api/Users`;
  const roles = `${window.globalConfig.BASE_URL2}/api/Roles`;
  const RandR = `${window.globalConfig.BASE_URL2}/api/RandR`;
  const onboarding = `${window.globalConfig.BASE_URL2}/api/EmployeesForOnBoardings`;
  const departments = `${window.globalConfig.BASE_URL2}/api/Departments`;

  const userTasks = useSelector((state) => state.auth.userTasks)?.split(",");

  const [cookieValue, setCookieValue] = useState(getCookie("ID"));

  const [path, setPath] = useState(null);
  const { bigContextState, setBigContextState } = useBigContext();

  function findName(data, targetName, currentPath = []) {
    function isInArray(name, arr) {
      for (let item of arr) {
        if (item.pathName === name) {
          return true;
        }
        if (item.children && isInArray(name, item.children)) {
          return true;
        }
      }
      return false;
    }
    if (!isInArray(pageName, jsonData)) {
      setPath(null);
      document.cookie = `CurrentOnboardingEmployee=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    } else {
      for (const item of data) {
        const updatedPath = [
          ...currentPath,
          { pathName: item.pathName, link: item.link },
        ];

        if (item.pathName === targetName) {
          setPath(updatedPath);
          return;
        }

        if (item.children.length > 0) {
          findName(item.children, targetName, updatedPath);
        }
      }
    }
  }
  useEffect(() => {
    findName(jsonData, pageName);
  }, [pageName]);
  useEffect(() => {
    const interval = setInterval(() => {
      const newValue = getCookie("ID");
      if (newValue !== cookieValue) {
        setCookieValue(newValue);
        //Do something with the updated cookie value
      }
    }, 1000); //Check every second
    fetchLoginStatus();

    return () => clearInterval(interval);
  }, [cookieValue]);

  //Function to get a cookie by name
  function getCookie(name) {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split("=");
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return "";
  }

  useEffect(() => {
    //if (isLoggedIn !== "true") {
    //  navigate("/login");
    //}
    const extractApplicantId = () => {
      const url = window.location.href;
      const startIndex =
        url.indexOf("/stage-1:-delisting-(initial-screening)/") !== -1
          ? url.indexOf("/stage-1:-delisting-(initial-screening)/") + 45
          : url.indexOf("/Prequalification-Stage-2-Scoring/") !== -1
            ? url.indexOf("/Prequalification-Stage-2-Scoring/") + 34
            : url.indexOf("/Qualified-Applicants-Scoring/") !== -1
              ? url.indexOf("/Qualified-Applicants-Scoring/") + 30
              : -1;
      const endIndex = url.indexOf("/", startIndex);

      if (startIndex !== -1 && endIndex !== -1) {
        const id = url.substring(startIndex, endIndex);
        setApplicantId(id);
      }
      const startIndex2 =
        url.indexOf("-position") !== -1 ? url.indexOf("-position") + 9 : -1;

      if (startIndex2 !== -1) {
        const id2 = url.substring(startIndex2);
        setApplicantId2(id2);
      }
    };
    setChanger("");
    extractApplicantId();
  }, [changer]);
  const fetchLoginStatus = async () => {
    try {
      const response = await fetch(`${login}/CurrentUser`, {
        method: "Get",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
        credentials: "include",
      });
      const data = await response.text();
      if (data.startsWith("Not logged in")) {
        setBigContextState({});
        const url = window.location.href; //Get the current URL
        const hasSlash = url.includes("vacant-position/");
        if (hasSlash) {
          const id = url.substring(url.lastIndexOf("/") + 1);
          document.cookie = `Redirect=${id}; expires=0; path=/;`;
        }
        const response = await fetch(`${login}/Logout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({}),
        });
        //const jsonData = await response.json();

        sessionStorage.clear();
        dispatch(logout());
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      } else {
        var pParsedData = JSON.parse(data);
        setBigContextState(pParsedData);
      }
    } catch (error) {
      console.error(error);
      const url = window.location.href; //Get the current URL
      const hasSlash = url.includes("vacant-position/");
      if (hasSlash) {
        const id = url.substring(url.lastIndexOf("/") + 1);
        document.cookie = `Redirect=${id}; expires=0; path=/;`;
      }
      navigate("/login");
    }
  };

  const handleChildVariable = (variable) => {
    setPageName(variable);
    if (
      variable === "Dashboard" ||
      variable === "Personal Data Sheet Form" ||
      variable === "Admin Dashboard" ||
      variable === "Job Positions" ||
      variable === "Prequalification Table" ||
      variable === "List Of User" ||
      variable === "Personal Data Sheet" ||
      variable === "Hiring Dashboard" ||
      variable === "Compose Email" ||
      variable === "List Of Roles" ||
      variable === "User Level Restrictions" ||
      variable === "Recycle Bin" ||
      variable === "Summary" ||
      //variable === "Profile Setting" ||
      //variable === "Phase 1 Pre Boarding" ||
      //variable === "Phase 1 Pre Boarding: Gallery" ||
      //variable === "Phase 2 Orientation Phase" ||
      //variable === "Phase 2 Orientation Phase: Orientation Evaluation" ||
      //variable === "Phase 2 Orientation Phase: Gallery" ||
      //variable === "Phase 3 Immersion Phase" ||
      //variable === "Phase 3 Immersion Phase: Journal" ||
      //variable === "Phase 3 Immersion Phase: Report" ||
      //variable === "Phase 3 Immersion Phase: Gallery" ||
      //variable === "Phase 4 Exploration Phase" ||
      //variable === "Phase 4 Exploration Phase: Coaching Session" ||
      //variable === "Phase 4 Exploration Phase: Mentorship Session" ||
      //variable === "Phase 5 Discovery Phase" ||
      //variable === "Phase 5 Discovery Phase: Formal Training Document" ||
      //variable === "Phase 5 Discovery Phase: Informal Training Document" ||
      //variable === "Phase 6 Engagement Phase" ||
      //variable === "Phase 6 Engagement Phase: Onboarding Feedback" ||
      //variable === "Phase 6 Engagement Phase: Gallery" ||
      //variable === "Phase 6 Engagement Phase: Individual Delopment Plan" ||
      //variable === "Competency Based Profile" ||
      //variable === "Competency Based Profile: Core Competency" ||
      //variable === "Competency Based Profile: Functional Competency" ||
      //variable === "Competency Based Profile: Leadership Competency" ||
      variable === "Employees For Onboarding" ||
      variable === "List Of Awards" ||
      variable === "Awarding Schedule" ||
      variable === "Nomination" ||
      variable === "PRAISE Committee" ||
      variable === "Judges' Ratings" ||
      variable === "Leave Application" ||
      variable === "Travel Order" ||
      variable === "Pass Slip" ||
      variable === "Messages" ||
      variable === "Archived Messages" ||
      variable === "Score Templates" ||
      variable === "Onboarding Setup" ||
      variable === "Onboarding" ||
      variable === "Coaching And Mentorship" ||
      variable === "List Of Departments" ||
      variable === "Psychosocial Criteria" ||
      variable === "Raters For Positions" ||
      variable === "HRMPSB Table" ||
      variable === "Pen Test" ||
      variable === "Profile Setting" ||
      variable === "Results"
    ) {
      setBreadcrumbVariable(true);
    } else {
      setBreadcrumbVariable(false);
    }
    setChanger(variable);
  };

  const dispatch = useDispatch();
  let timeoutId;

  const resetTimeout = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(handleTimeout, 30000000);
  };

  const handleUserActivity = () => {
    resetTimeout();
  };

  const handleTimeout = () => {
    MySwal.fire({
      title: "You have been logged out due to inactivity",
      text: "",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        const fetchData = async () => {
          try {
            const response = await fetch(`${login}/Logout`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              mode: "cors",
              credentials: "include",
              body: JSON.stringify({}),
            });
            //const jsonData = await response.json();

            sessionStorage.clear();
            dispatch(logout());
            setTimeout(() => {
              navigate("/login");
            }, 1000);
          } catch (error) {
            console.log("Error fetching data:", error);
          }
        };

        fetchData();
      }
    });
    //Perform your desired action when the user becomes idle
  };

  useEffect(() => {
    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);
    document.addEventListener("mousedown", handleUserActivity);
    document.addEventListener("touchstart", handleUserActivity);

    resetTimeout();

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
      document.removeEventListener("mousedown", handleUserActivity);
      document.removeEventListener("touchstart", handleUserActivity);
    };
  }, []);
  const MySwal = withReactContent(Swal);

  const [saveChecker, setSaveChecker] = useState(
    cookies.profileChecker === "true" ? true : false
  );

  useEffect(() => {
    setSaveChecker(cookies.profileChecker === "true" ? true : false);
  }, [cookies.profileChecker]);
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await fetch(`${users}/GetSingle`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            ID: Id,
          }),
        });

        const jsonData = await response.json();
        setSaveChecker(jsonData.user.birthDate ? true : false);
        document.cookie = `profileChecker=${jsonData.user.birthDate ? true : false
          }; expires=0; path=/;`;

        const response2 = await fetch(`${roles}/Get`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            ID: jsonData.userRoles[0]?.roleID,
          }),
        });
        const jsonData2 = await response2.json();
        const AdminChecker = jsonData2.rows[0]?.tasks;

        document.cookie = `RoleID=${jsonData.userRoles[0]?.roleID}; expires=0; path=/;`;
        document.cookie = `RoleName=${jsonData.userRoles[0]?.roleName}; expires=0; path=/;`;
        document.cookie = `Tasks=${jsonData2.rows[0]?.tasks}; expires=0; path=/;`;

        const response4 = await fetch(`${RandR}/getSkedAwardsPerJudge`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            parameter_1: Id,
          }),
        });
        const judge = await response4.json();
        document.cookie = `isJudge=${judge.length > 0 ? true : false
          }; expires=0; path=/;`;

        const response5 = await fetch(`${onboarding}/Get`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            ID: null,
          }),
        });
        const jsonData5 = await response5.json();
        const filteredArray = jsonData5.rows.filter(
          (item) => item.coachID === Id || item.mentorID === Id
        );
        document.cookie = `isCoachMentor=${filteredArray.length > 0 ? true : false
          }; expires=0; path=/;`;
        let jsonData6 = [{ rows: [] }];
        const response6 = await fetch(`${departments}/Get`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            ID: null,
          }),
        });
        if (response6.ok) {
          jsonData6 = await response6.json();
        }
        if (
          AdminChecker?.length > 0 &&
          AdminChecker[0] != "null" &&
          AdminChecker[0] != ""
        ) {
          if (
            AdminChecker?.some(
              (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
            ) &&
            AdminChecker?.length < 2
          ) {
            document.cookie = `isEmployee=false; expires=0; path=/;`;
          } else {
            document.cookie = `isEmployee=true; expires=0; path=/;`;
          }
        } else {
          document.cookie = `isEmployee=false; expires=0; path=/;`;
        }
        if (
          AdminChecker?.length > 0 &&
          AdminChecker[0] != "null" &&
          AdminChecker[0] != ""
        ) {
          if (
            AdminChecker?.some(
              (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
            ) &&
            AdminChecker?.length < 3
          ) {
            document.cookie = `isAdmin=false; expires=0; path=/;`;
            dispatch(
              login_Success({
                userRole: `${jsonData.userRoles[0]?.roleName}`,
                userTasks: `${jsonData2.rows[0]?.tasks}`,
                hasProfile: jsonData.user.birthDate ? true : false,
                isLoggedIn: true,
                isJudge: judge.length > 0 ? true : false,
                isCoachMentor: filteredArray.length > 0 ? true : false,
                isDeptHead: jsonData6.rows.some((item) => item.headID === Id),
                isAdmin: false,
                isEmployee:
                  AdminChecker?.length > 0 &&
                    AdminChecker[0] != "null" &&
                    AdminChecker[0] != "" &&
                    !(
                      AdminChecker?.some(
                        (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
                      ) && AdminChecker?.length < 2
                    )
                    ? true
                    : false,
              })
            );
          } else {
            dispatch(
              login_Success({
                userRole: `${jsonData.userRoles[0]?.roleName}`,
                userTasks: `${jsonData2.rows[0]?.tasks}`,
                hasProfile: jsonData.user.birthDate ? true : false,
                isLoggedIn: true,
                isJudge: judge.length > 0 ? true : false,
                isCoachMentor: filteredArray.length > 0 ? true : false,
                isDeptHead: jsonData6.rows.some((item) => item.headID === Id),
                isAdmin: true,
                isEmployee:
                  AdminChecker?.length > 0 &&
                    AdminChecker[0] != "null" &&
                    AdminChecker[0] != "" &&
                    !(
                      AdminChecker?.some(
                        (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
                      ) && AdminChecker?.length < 2
                    )
                    ? true
                    : false,
              })
            );
            document.cookie = `loggedIn=true; expires=0; path=/;`;
            document.cookie = `isAdmin=true; expires=0; path=/;`;
          }
        } else {
          document.cookie = `isAdmin=false; expires=0; path=/;`;
          setTimeout(() => {
            dispatch(
              login_Success({
                userRole: `${jsonData.userRoles[0]?.roleName}`,
                userTasks: `${jsonData2.rows[0]?.tasks}`,
                hasProfile: jsonData.user.birthDate ? true : false,
                isLoggedIn: true,
                isJudge: judge.length > 0 ? true : false,
                isCoachMentor: filteredArray.length > 0 ? true : false,
                isDeptHead: jsonData6.rows.some((item) => item.headID === Id),
                isAdmin: false,
                isEmployee:
                  AdminChecker?.length > 0 &&
                    AdminChecker[0] != "null" &&
                    AdminChecker[0] != "" &&
                    !(
                      AdminChecker?.some(
                        (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
                      ) && AdminChecker?.length < 2
                    )
                    ? true
                    : false,
              })
            );
          }, 2500);
        }
      } catch (error) { }
    };
    fetchUserRole();
  }, [pageName]);
  const [preQualisPresent, setPreQualisPresent] = useState(
    userTasks?.some((item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4")
  );
  const [rolesisPresent, setRolesisPresent] = useState(
    userTasks?.some((item) => item === "ACA50AA8-3666-49DD-9B61-F0E146B23663")
  );
  const [usersisPresent, setUsersisPresent] = useState(
    userTasks?.some((item) => item === "84253EEA-122E-471E-B117-7A46988192CB")
  );
  const [addPreQualIsPresent, setAddPreQualIsPresent] = useState(
    userTasks?.some((item) => item === "758A10F7-AFBC-4D36-81EA-D9D48C9ADD43")
  );
  const [editPreQualIsPresent, setEditPreQualIsPresent] = useState(
    userTasks?.some((item) => item === "905A976B-4375-492E-BB51-EEC1976C3F2C")
  );
  const [deletePreQualIsPresent, setDeletePreQualIsPresent] = useState(
    userTasks?.some((item) => item === "41555934-4071-4DAB-B144-E6A56CAEB440")
  );
  const [isAdmin, setisAdmin] = useState(cookies.isAdmin === "true");
  useEffect(() => {
    setPreQualisPresent(
      userTasks?.some((item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4")
    );
    setRolesisPresent(
      userTasks?.some((item) => item === "ACA50AA8-3666-49DD-9B61-F0E146B23663")
    );
    setUsersisPresent(
      userTasks?.some((item) => item === "84253EEA-122E-471E-B117-7A46988192CB")
    );
    setAddPreQualIsPresent(
      userTasks?.some((item) => item === "758A10F7-AFBC-4D36-81EA-D9D48C9ADD43")
    );
    setEditPreQualIsPresent(
      userTasks?.some((item) => item === "905A976B-4375-492E-BB51-EEC1976C3F2C")
    );
    setDeletePreQualIsPresent(
      userTasks?.some((item) => item === "41555934-4071-4DAB-B144-E6A56CAEB440")
    );
    if (userTasks?.length > 0 && userTasks[0] != "null" && userTasks[0] != "") {
      if (
        userTasks?.some(
          (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
        ) &&
        userTasks?.length < 3
      ) {
        setisAdmin(false);
        document.cookie = `isAdmin=false; expires=0; path=/;`;
      } else {
        setisAdmin(true);
        document.cookie = `isAdmin=true; expires=0; path=/;`;
      }
    } else {
      setisAdmin(false);
      document.cookie = `isAdmin=false; expires=0; path=/;`;
    }
  }, [userTasks]);
  return (
    <>
      <div className="sticky top-0 z-1000">
        <header className="bg-white shadow drop-shadow-1 py-3 px-2  dark:bg-boxdark dark:drop-shadow-none h-[70px]">
          <div className="grid grid-cols-7 lg:grid-cols-6 items-start justify-between  md:px-8 2xl:px-11 h-full">
            <div className="flex  items-center justify-between gap-2 sm:gap-4 lg:hidden">
              {/* <!-- Hamburger Toggle BTN --> */}
              <button
                aria-controls="sidebar"
                aria-expanded={props.sidebarOpen}
                onClick={(e) => {
                  e.stopPropagation();
                  props.setSidebarOpen(!props.sidebarOpen);
                }}
                className="z-99999 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
              >
                <span className="relative block h-5.5 w-5.5 cursor-pointer">
                  <span className="du-block absolute right-0 h-full w-full">
                    <span
                      className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!w-full delay-300"
                        }`}
                    ></span>
                    <span
                      className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-150 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "delay-400 !w-full"
                        }`}
                    ></span>
                    <span
                      className={`relative top-0 left-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-200 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!w-full delay-500"
                        }`}
                    ></span>
                  </span>
                  <span className="absolute right-0 h-full w-full rotate-45">
                    <span
                      className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!h-0 !delay-[0]"
                        }`}
                    ></span>
                    <span
                      className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-white ${!props.sidebarOpen && "!h-0 !delay-200"
                        }`}
                    ></span>
                  </span>
                </span>
              </button>
              {/* <!-- Hamburger Toggle BTN --> */}
            </div>
            <div className="flex self-center mt-0.5 justify-start items-center col-span-5 md:col-span-5">
              <Breadcrumb onVariableChange={handleChildVariable} />
              {path?.some(
                (person) =>
                  person.pathName === "Employees For Onboarding" ||
                  person.pathName === "Coaching And Mentorship"
              ) &&
                path?.every(
                  (person) => person.pathName !== "Adding To Onboarding"
                ) &&
                path.length > 1 ? (
                <span className="text-black text-lg font-semibold indent-1.5 uppercase">
                  {cookies.CurrentOnboardingEmployee}
                </span>
              ) : (
                <></>
              )}
            </div>

            {/* <div>
          <Notification/>
        </div> */}

            <div className="flex self-center justify-end items-center z-9999 col-span-1 gap-x-6">
              {/* <div className="hidden md:block">
            <Notification/>
            </div> */}
              <AvatarDropdown />
            </div>
          </div>
        </header>
        {path?.length > 1 ? (
          <div className="flex h-fit px-10 pt-5 pb-1 bg-white">
            {path?.map((item, index) => (
              <>
                <button
                  onClick={() =>
                    navigate(
                      item.link
                        .replace(":id3", id3)
                        .replace(":id2", id2)
                        .replace(":id", id),
                      {
                        replace: true,
                      }
                    )
                  }
                  //disabled={index + 1 === path.length}
                  className={`whitespace-nowrap ${index + 1 === path.length &&
                      !(
                        (pageName === "Vacant Position" ||
                          pageName === "Applied Position" ||
                          pageName === "Archived Position") &&
                        id
                      )
                      ? "hidden"
                      : "hover:underline hover:text-blue-800 underline-offset-2"
                    }`}
                >
                  {item.pathName}
                </button>
                <span
                  className={`${index + 2 < path.length ||
                      ((pageName === "Vacant Position" ||
                        pageName === "Applied Position" ||
                        pageName === "Archived Position") &&
                        id &&
                        index + 2 === path.length)
                      ? " font-semibold text-center flex items-center justify-center border-solid border-x mx-2 border-gray-400 border"
                      : "hidden"
                    }`}
                ></span>
              </>
            ))}
          </div>
        ) : (
          <></>
        )}
        <div className="h-2 w-full bg-white"></div>
      </div>
    </>
  );
};

export default Navbar;
